/** Лейбл режима модели («Text to Image», «Music»…) — общий для ModelBadge
 *  и «?»-справки (ModelHelpSheet). Вынесен из ModelBadge.tsx: react-refresh
 *  требует, чтобы файлы компонентов экспортировали только компоненты. */
export function modelModeLabel(opts: {
	modelName: string
	isVideo: boolean
	requiresVideo: boolean
	requiresImage: boolean
	isAudio?: boolean
	isPresentation?: boolean
}): string {
	const detectedAudio = opts.isAudio || opts.modelName.toLowerCase().includes('suno')
	const detectedPresentation =
		opts.isPresentation || opts.modelName.toLowerCase().includes('slide') || opts.modelName.toLowerCase().includes('umnik-slides')
	return detectedAudio
		? 'Music'
		: detectedPresentation
			? 'Slides'
			: opts.isVideo
				? opts.requiresVideo
					? 'Video to Video'
					: opts.requiresImage
						? 'Image to Video'
						: 'Text to Video'
				: opts.requiresImage
					? 'Image to Image'
					: 'Text to Image'
}
